/**
 * Create a session token for address suggestion billing grouping.
 *
 * Session tokens group autocomplete requests for billing purposes.
 * Create one when the user starts typing (e.g. on input focus),
 * pass it to all suggestAddresses() calls in that session,
 * and discard it when the user makes a selection.
 */
export function createSessionToken(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  // Fallback for environments without crypto.randomUUID
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}
